import React from "react";
import { Helmet } from "react-helmet";
import PageTitle from "../components/PageTitle";
import { Settings } from "../configuration/settings";
import Breadcrumbs from "../components/Breadcrumbs";

function Contacts() {
    return (
        <>
            <Helmet>
                <title>Контакти {Settings.shopName} - оригінальні чоловічі джинси Levi’s</title>
                <meta name="description" content={`Потрібна допомога з розміром або замовленням джинсів Levi’s? Контакти ${Settings.shopName} для швидкої консультації.`} />
                <link rel="canonical" href={`${Settings.siteUrl}/contacts/`} />
            </Helmet>
            <Breadcrumbs items={[ { text: "Контакти"} ]} />
            <PageTitle title="Контакти" />
            <div className="text-start">
                <p>
                    Ми завжди на зв'язку, щоб допомогти вам обрати <strong>оригінальні чоловічі джинси Levi’s</strong> та 
                    зробити покупку максимально комфортною.
                </p>

                <h2 className="fs-5">Зв'яжіться з нами</h2>
                <p>
                    У вас є запитання щодо розмірів, моделей або наявності товару? Напишіть - ми швидко відповімо:
                </p>
                <ul>
                    <li>
                        <strong>Telegram: </strong>
                        <a 
                            className="link-secondary"
                            target="_blank"
                            rel="nofollow"
                            href={`https://t.me/${Settings.telegramName}/`}
                            title={`Telegram магазину ${Settings.shopName}`}
                        >
                            <b>@{Settings.telegramName}</b>
                        </a>
                    </li>
                    <li><strong>Instagram: </strong>
                        <a 
                            className="link-secondary"
                            target="_blank"
                            rel="nofollow"
                            href={`https://instagram.com/${Settings.instagramName}/`}
                            title={`Instagram магазину ${Settings.shopName}`}
                        >
                            <b>@{Settings.instagramName}</b>
                        </a>
                    </li>
                </ul>

                <h2 className="fs-5">Робочий час</h2>
                <p>
                    Ми працюємо онлайн щодня, щоб ви могли отримати консультацію у зручний для вас час:
                </p>
                <ul>
                    <li><strong>Пн–Пт:</strong> 10:00 – 19:00</li>
                    <li><strong>Сб–Нд:</strong> 11:00 – 17:00</li>
                </ul>

                <h2 className="fs-5">Підписка на новини та акції</h2>
                <p>
                    Підпишіться на нашу сторінку 
                    в <a 
                        className="link-secondary"
                        target="_blank"
                        rel="nofollow"
                        href={`https://instagram.com/${Settings.instagramName}/`}
                        title={`Instagram магазину ${Settings.shopName}`}
                    >
                        <b>Instagram</b>
                    </a>, 
                    щоб першими дізнаватися про нові моделі джинсів Levi’s, розпродажі та спеціальні пропозиції.
                </p>

                <h2 className="fs-5">Чому обирають {Settings.shopName}</h2>
                <ul>
                    <li>Продаємо тільки <strong>оригінальні чоловічі джинси Levi’s</strong></li>
                    <li>Професійна консультація щодо розмірів і моделей</li>
                    <li>Швидка обробка замовлень та доставка по всій Україні</li>
                </ul>

                <p>
                    Ваші питання та відгуки важливі для нас. Зв'яжіться з нами будь-яким зручним способом -
                    ми завжди на боці клієнта.
                </p>
            </div>
        </>
    );
}

export default Contacts;